import { tempMedia } from '@/utils/tempMedia';

export default function useTempMedia() {
  return {
    obter(key) {
      if (!key) return [];
      return tempMedia[key] ? tempMedia[key] : [];
    },
    adicionar(key, media) {
      if (!key) return;
      if (!tempMedia[key]) tempMedia[key] = [];
      tempMedia[key].push(media);
    },
    remover(key, index) {
      if (!key || !tempMedia[key]) return;
      if (index >= 0 && index < tempMedia[key].length) tempMedia[key].splice(index, 1);
    },
    limpar(key) {
      if (key) {
        delete tempMedia[key];
      } else {
        for (const k in tempMedia) delete tempMedia[k];
      }
    },
    todos() { return tempMedia; }
  };
}
